import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

const DesktopHeaderContainer = styled("div", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{
    $enableCentreTitle: boolean
    $breadcrumbsEnabled?: boolean
    $isMerchandisedUrl: boolean
    $urlIsSaleOrClearance?: boolean
}>`
    display: grid;
    grid-template-areas: ${props => (props.$enableCentreTitle ? '"empty title end"' : '"title empty end"')};
    grid-template-columns: ${props => (props.$enableCentreTitle ? "1fr 7fr 1fr" : "20fr 0fr 1fr")};
    width: 100%;
    padding-bottom: 0.75rem;
    overflow: visible;
    @media (min-width: ${breakpoints.values.md}px) {
        grid-template-columns: ${props => (props.$enableCentreTitle ? "1fr 7fr 1fr" : "1fr 0fr 0fr")};
        padding: ${({$urlIsSaleOrClearance}) => ($urlIsSaleOrClearance ? "1.25rem 1rem 0.75rem 1rem" : 0)};
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        grid-template-columns: ${props => (props.$enableCentreTitle ? "4fr 7fr 4fr" : "auto 0fr 2fr")};
        transform: ${({$breadcrumbsEnabled, $isMerchandisedUrl}) =>
            $breadcrumbsEnabled && $isMerchandisedUrl ? "translateY(-0.6875rem)" : "translateY(-0.75rem)"};
        position: fixed;
        background: white;
        z-index: 2;
        height: 3.75rem;
        padding: 1.0625rem 3rem 3.5rem 1rem;
    }
    @media (min-width: ${breakpoints.values.xl}px) {
        max-width: 77rem;
        padding: 1.0625rem 1rem 3.5rem 1rem;
    }
`
DesktopHeaderContainer.displayName = "Cotton22DesktopHeaderContainer"

export default DesktopHeaderContainer
